// Liste des métiers proposés dans les comboboxes secteur (Onboarding + Settings).
// Source unique — un seul endroit à enrichir. Le backend (SectorEconomics) sait
// chiffrer chacun ; un secteur hors liste déclenche l'estimation IA partagée.
export const SECTORS = [
  // — Beauté & bien-être —
  'Institut de beauté', 'Coiffure', 'Coiffure & barbier', 'Barbier', 'Onglerie',
  'Spa & massages', 'Esthétique', 'Épilation', 'Maquillage / make-up', 'Extension de cils',
  'Tatouage', 'Bronzage / solarium', 'Toilettage animalier',
  // — Restauration & bouche —
  'Restaurant', 'Café / bar', 'Bar à cocktails', 'Brasserie', 'Traiteur',
  'Boulangerie', 'Pâtisserie', 'Boucherie', 'Charcuterie', 'Poissonnerie', 'Fromagerie',
  'Pizzeria', 'Tea-room', 'Food truck', 'Kebab / snack', 'Crêperie', 'Glacier',
  'Chocolatier', 'Torréfacteur', 'Sushi / cuisine asiatique',
  // — Automobile —
  'Garage automobile', 'Carrosserie', 'Lavage auto', 'Mécanique moto', 'Vente de pneus',
  'Concessionnaire auto', 'Contrôle technique', 'Magasin de vélos',
  // — Commerce de détail —
  'Boutique de mode', 'Bijouterie', 'Horlogerie', 'Fleuriste', 'Librairie', 'Papeterie',
  'Épicerie fine', 'Cave à vin', 'Magasin de sport', 'Décoration / meubles', 'Jouets & cadeaux',
  'Animalerie', 'Quincaillerie / bricolage', 'Opticien', 'Droguerie', 'Concept store',
  'Magasin bio', 'Vape / CBD', "Galerie d'art", 'Antiquités / brocante',
  // — Sport & fitness —
  'Fitness / salle de sport', 'Yoga / pilates', 'Coach sportif', 'Studio de danse',
  'Arts martiaux', 'Crossfit', 'Escalade', 'Tennis / squash', 'École de natation',
  'Équitation / manège',
  // — Santé —
  'Physiothérapie', 'Ostéopathie', 'Cabinet dentaire', 'Orthodontie', 'Cabinet médical',
  'Pharmacie', 'Vétérinaire', 'Podologie', 'Naturopathie', 'Psychologie',
  'Nutrition / diététique', 'Chiropraxie', 'Sage-femme', 'Logopédie', 'Ergothérapie',
  'Acupuncture', 'Sophrologie', 'Soins à domicile', 'Ambulance',
  // — Artisanat & bâtiment —
  'Menuiserie', 'Ébénisterie', 'Électricité', 'Plomberie / chauffage', 'Chauffagiste',
  'Peinture / plâtrerie', 'Jardinage / paysagisme', 'Nettoyage', 'Construction / maçonnerie',
  'Serrurerie', 'Couverture / toiture', 'Ferblanterie', 'Carrelage', 'Vitrerie', 'Charpente',
  'Ramonage', 'Climatisation / ventilation', 'Domotique', 'Isolation / façade', 'Terrassement',
  'Pisciniste', 'Cuisiniste / agencement', 'Stores / volets', 'Parquet / sols',
  // — Transport & logistique —
  'Transport / taxi', 'VTC / chauffeur privé', 'Déménagement', 'Coursier / livraison', 'Logistique',
  // — Services professionnels —
  'Fiduciaire', 'Comptabilité', 'Assurance / courtage', 'Architecture', 'Avocat / notaire',
  'Conseil / consulting', 'Ingénierie', 'Géomètre', 'Informatique / IT', 'Développement web',
  'Cybersécurité', 'Ressources humaines / recrutement', 'Traduction', 'Coaching professionnel',
  'Gestion de fortune', 'Secrétariat / administration',
  // — Immobilier —
  'Immobilier / régie', 'Courtier immobilier', 'Promotion immobilière', 'Gérance / syndic',
  // — Agence & création —
  'Marketing / communication', 'Agence web', 'Publicité', 'Graphisme / design', 'Photographe',
  'Vidéaste', 'Community management', 'Imprimerie', 'Sérigraphie', 'Signalétique / enseigne',
  'Rédaction / copywriting', 'Production audiovisuelle',
  // — Hôtellerie —
  'Hôtel / B&B', "Chambre d'hôtes", 'Gîte / location vacances', 'Camping', 'Auberge',
  // — Formation & enfance —
  'École / formation', 'Auto-école', "Crèche / garde d'enfants", 'Soutien scolaire',
  'Cours de langue', 'École de musique', 'Cours de cuisine',
  // — Événementiel —
  'Événementiel', 'Wedding planner', 'DJ / animation', 'Sonorisation', 'Location de matériel',
  'Artiste / musicien',
  // — Terroir & autres —
  'Vigneron / œnologie', 'Agriculture / terroir', 'Brasserie artisanale', 'Tourisme / loisirs',
  'Club sportif', 'Association', 'Sécurité',
];

// minuscule + sans accents, pour un filtre robuste
export const normSector = (t) =>
  (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
